import { useState, useEffect } from "react";
import getConfig from "next/config";
import classNames from "classnames";
import PromoMobileMenuCategory from "@containers/Promo/PromoMobileMenu/PromoMobileMenuCategory";
import MenuIcon from "@components/Icons/Menu";
import AnimatedMenuIcon from "@components/Icons/MainMenu";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const isBricoStore = websiteName === "bricostore";

const PromoMobileMenu = ({
  categories,
  context,
  campaignSlug,
  currentPageCategory,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeTree, setActiveTree] = useState({
    categorySlug: null,
    subCategorySlug: null,
    subSubCategorySlug: null,
  });

  // TODO: check logic and refactor
  useEffect(() => {
    if (isOpen) {
      setIsOpen(!isOpen);
    }

    setActiveTree({
      categorySlug: context.categoryLevel1 || categories[0].slug,
      subCategorySlug: context.categoryLevel2 || null,
      subSubCategorySlug: context.categoryLevel3 || null,
    });
  }, [context.categoryLevel1, context.categoryLevel2, context.categoryLevel3]);

  const handleSetActive = ({
    categorySlug,
    subCategorySlug,
    subSubCategorySlug,
  }) => {
    setActiveTree({
      categorySlug,
      subCategorySlug,
      subSubCategorySlug,
    });
  };

  const handleMobileMenuToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="bg-[#EDEDED] group-with-promoDarkTheme:bg-[#2E2E2E] group-with-promoDarkTheme:text-white p-2 px-3 sm:px-4 lg:p-0 lg:w-auto lg:bg-transparent group-with-promoDarkTheme:lg:bg-transparent relative">
      <button
        className={classNames(
          "lg:hidden flex items-center outline-none font-bold text-sm py-1 w-full group-with-promoDarkTheme:text-white",
          {
            // Brico: brand-red icon + title, and the homepage animated hamburger→X.
            "text-red-brand": isBricoStore,
            opened: isBricoStore && isOpen,
          }
        )}
        onClick={handleMobileMenuToggle}
      >
        {isBricoStore ? (
          <span className="pointer-events-none flex">
            <AnimatedMenuIcon width="28px" height="28px" />
          </span>
        ) : !isOpen ? (
          <MenuIcon width="20px" />
        ) : (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="1.33789"
              y="0.324463"
              width="20"
              height="1.89189"
              rx="0.945946"
              transform="rotate(45 1.33789 0.324463)"
            />
            <rect
              x="15.7285"
              y="1.33789"
              width="20"
              height="1.89189"
              rx="0.945946"
              transform="rotate(135 15.7285 1.33789)"
            />
          </svg>
        )}

        <span className="ml-2 text-base font-medium">Categorii de oferte</span>
      </button>

      <div
        className={`${
          isOpen ? "absolute " : "hidden"
        } inset-x-0 top-[45px] bg-[#EDEDED] group-with-promoDarkTheme:bg-[#2E2E2E] z-50 px-10`}
      >
        {categories.map((category) => {
          const isActiveCategory = activeTree.categorySlug === category.slug;

          return (
            <div
              key={category.id}
              className="border-b border-[#A2A2A2] max-w-[480px]"
            >
              <PromoMobileMenuCategory
                id={category.id}
                currentPageCategory={currentPageCategory}
                name={category.name}
                slug={category.slug}
                link={`/promo/${campaignSlug}/${category.slug}`}
                isActive={isActiveCategory}
                activeTree={{
                  category: activeTree.categorySlug,
                  subCategorySlug: activeTree.subCategorySlug,
                  subSubCategorySlug: activeTree.subSubCategorySlug,
                }}
                subcategories={category.subcategories}
                onSetActive={handleSetActive}
              />
            </div>
          );
        })}

        {/* {settings.websiteName === "altex" && campaignSlug === "black-friday" && (
          <div className="py-3 font-semibold border-b border-[#A2A2A2] max-w-[480px]">
            <a
              href="https://www.altextravel.ro/SimplyBlackFriday/"
              title=""
              target="_blank"
              className="block"
              rel="noreferrer"
            >
              Vacante
            </a>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default PromoMobileMenu;
